<flx-modal
  [dismissible]="true"
  (dismiss)="close()"
  class="flx-ds"
  data-testid="export-review-modal"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Download export
  </div>

  <div
    class="flex flex-col items-center"
    flxModalHeaderSubtitle
  >
    @if (notification.hasContext) {
      <flx-notification-context
        [notification]="notification"
        class="mt-1"
      />
    }

    <flx-notification-summary [summary]="notification.summary" />
  </div>

  <div class="flx-modal-body flex flex-col gap-4">
    <div
      class="flex gap-2.5 rounded-lg border border-yellow-100 bg-yellow-50 px-3.5 py-3 text-xs/normal text-yellow-800"
    >
      <i class="ph ph-warning leading-normal"></i>
      <span>
        These resources don't exist on <b>{{ targetVersion }}</b> and will be <b>excluded</b> from
        the downloaded ZIP. Download anyway, or change the target version.
      </span>
    </div>

    @if (excludedResources.isLoading()) {
      <div class="flex justify-center py-6">
        <flx-spinner size="small" />
      </div>
    } @else if (excludedResources.error()) {
      <p class="text-xs text-neutral-500">The excluded resources could not be loaded.</p>
    } @else {
      @let resources = excludedResources.value();

      <div class="flex flex-col gap-1">
        <span class="text-base font-bold text-neutral-900">
          Excluded resources
          <span class="font-semibold text-neutral-500">({{ resources.length }})</span>
        </span>

        <div class="flex max-h-[400px] flex-col overflow-y-auto">
          @for (resource of resources; track $index) {
            <div
              class="flex items-center gap-3 border-b border-neutral-50 py-3 last:border-b-0"
              data-testid="export-review-excluded-resource"
            >
              <div class="h-5 w-1 flex-none rounded-[2px] bg-neutral-200"></div>
              <div
                [pTooltip]="resource.breadcrumb + resource.name"
                [showOnEllipsis]="true"
                class="truncate text-sm text-neutral-500"
                tooltipPosition="bottom"
                tooltipStyleClass="text-xs"
              >
                <span>{{ resource.breadcrumb }}</span>
                <strong class="font-bold text-neutral-900">{{ resource.name }}</strong>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="onActionClick(ExportReviewOption.CHANGE_TARGET_VERSION)"
        class="flx-ds secondary"
        data-testid="export-review-change-target-button"
        flxButton
        type="button"
      >
        Change Target Version
      </button>
      <button
        (click)="onActionClick(ExportReviewOption.DOWNLOAD)"
        class="flx-ds primary"
        data-testid="export-review-download-button"
        flxButton
        icon="left"
        type="button"
      >
        <i
          class="ph ph-download-simple"
          flxIcon
        ></i>
        Download anyway
      </button>
    </div>
  </div>
</flx-modal>
